// extracted by mini-css-extract-plugin
module.exports = {"tnc":"style_tnc__4noOF","error":"style_error__17sPe"};